import {
  UpdateProfileDocument,
  UpdateProfileMutation,
  UpdateProfileMutationVariables
} from '~/data';
import { client } from '~/data/client';

export interface ProfileSlice {
  id: string;
  auditoryFeedback: boolean;
  autoPlay?: boolean;
  darkMode?: string;
  mediumLocale: string;
  subtitles: boolean;
  textLocale: string;
  subtitleLocale: string;
  visualFeedback: boolean;
}

/**
 * Saves profile data on the back-end
 * @param variables The GraphQL query variables
 * @returns The values that have been updated
 */
export async function updateProfileData(
  variables: UpdateProfileMutationVariables
) {
  const result = await client.mutate<
    UpdateProfileMutation,
    UpdateProfileMutationVariables
  >({
    mutation: UpdateProfileDocument,
    variables
  });

  if (result.errors?.length) {
    throw new Error('Error saving profile information...');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { __typename, ...values } =
    result.data!.updateProfile!.learnerTraining!;

  return values as Pick<ProfileSlice, keyof typeof values>;
}
